import React, { useEffect, useState } from "react";
import MUIDataTable from "mui-datatables";
import {
  Button,
  IconButton,
  Tooltip,
  DialogContent,
  Dialog,
  DialogActions,
  TextField,
  Autocomplete,
} from "@mui/material";
import moment from "moment";
import { toast } from "react-toastify";
import { Close } from "@mui/icons-material";
import Card from "@mui/material/Card";
import Axios from "../axios";
import { Avatar } from "@mui/material";
import LibraryBooksSharpIcon from "@mui/icons-material/LibraryBooksSharp";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import BlockOutlinedIcon from "@mui/icons-material/BlockOutlined";
import { CSVLink } from "react-csv";
import DownloadIcon from "@mui/icons-material/Download";
import { useNavigate } from "react-router-dom";
import CircleIcon from "@mui/icons-material/Circle";
import { Helmet } from "react-helmet";
import { useAuth } from "../auth/authContext";
import { useLocation } from "react-router-dom";

const UserManagement = () => {
  const { navData } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [name, setName] = useState();
  const [email, setEmail] = useState();
  const [affiliateType, setAffiliateType] = useState();
  const [affiliateLink, setAffiliateLink] = useState();
  const [packages, setPackages] = useState();
  const [gender, setGender] = useState();
  const [allPackages, setAllPackages] = useState([]);
  const [city, setCity] = useState();
  const [allUsers, setAllUsers] = useState([]);
  const [userId, setUserId] = useState();
  const [opendel, setOpenDel] = useState(false);
  const [type, setType] = useState();
  const [page, setPage] = useState(0);
  const [count, setCount] = useState(0);
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState(true);
  const [userStatus, setUserStatus] = useState(false);
  const [userImg, setUserImg] = useState("");
  const [packagestatus, setPackageStatus] = useState("");
  const [write, setWrite] = useState(false);
  //data for the CSV file
  const [downloadData, setDownloadData] = useState([]);
  const [affiliateTypesData, setAffiliateTypesData] = useState([]);
  //header for the CSv file
  const headers = [
    { label: "Name", key: "name" },
    { label: "Email", key: "mail" },
    { label: "AffiliateType", key: "affiliateType" },
    { label: "Package", key: "role" },
    { label: "Created Date", key: "createdAt" },
    { label: "Package Status", key: "subscriptionStatus" },
    { label: "City", key: "city" },
    { label: "User Status", key: "userStatus" },
  ];
  useEffect(() => {
    fetchAllUsers(0, "");
    handleDownloadProcess();
    fetchallSubscriptions(0, "");
    getAffiliateTypes();
  }, []);
  useEffect(() => {
    const currentPath = location.pathname;
    const matchingNavItem = navData.find((item) => item.link === currentPath);
    if (matchingNavItem) {
      setWrite(matchingNavItem.write);
    } else {
      setWrite(false);
    }
  }, [location.pathname, navData]);
  const fetchAllUsers = (page, search) => {
    let data = {
      page: page,
      searchChar: search,
    };
    Axios.post(process.env.REACT_APP_BACKEND + "get-all-user", data)
      .then((resp) => {
        setAllUsers(resp?.data?.data?.docs);
        setCount(resp?.data?.data?.totalDocs);
      })
      .catch((err) => {
        toast.error(
          err && err.response && err.response.data && err.response.data.message
        );
      });
  };
  const fetchallSubscriptions = (page, search) => {
    let data = {
      page: page,
    };
    Axios.post(process.env.REACT_APP_BACKEND + "get-all-subscription", data)
      .then((resp) => {
        setAllPackages(resp?.data?.data?.docs);
      })
      .catch((err) => {
        toast.error(
          err && err.response && err.response.data && err.response.data.message
        );
      });
  };
  //API CSV Data
  const handleDownloadProcess = () => {
    Axios.post(process.env.REACT_APP_BACKEND + "get-user-csv-data")
      .then((resp) => {
        setDownloadData(resp?.data?.data);
      })
      .catch((err) => {
        toast.error(
          err && err.response && err.response.data && err.response.data.message
        );
      });
  };

  //Get Affiliate Type
  const getAffiliateTypes = () => {
    Axios.post(process.env.REACT_APP_BACKEND + "get-affiliatetypes")
      .then((resp) => {
        setAffiliateTypesData(resp?.data?.data?.docs);
      })
      .catch((err) => {
        toast.error(
          err && err.response && err.response.data && err.response.data.message
        );
      });
  };

  //-------------option for the mui table----------------------------
  const options = {
    responsive: "standard",
    selectableRows: "none",
    filter: false,
    viewColumns: false,
    serverSide: true,
    rowsPerPageOptions: [],
    count: count,
    page,
    download: false,

    onTableChange: (action, tableState) => {
      if (action === "changePage") {
        fetchAllUsers(tableState.page, search);
        setPage(tableState.page);
      }
    },
    onSearchChange: (searchText) => {
      fetchAllUsers(page, searchText);
      setSearch(searchText);
    },
    customToolbar: () => (
      <>
        <Tooltip title="Download">
          <IconButton>
            <CSVLink
              data={downloadData}
              headers={headers}
              filename={"User.csv"}
            >
              <DownloadIcon />
            </CSVLink>
          </IconButton>
        </Tooltip>
      </>
    ),
  };

  const columns = [
    {
      name: "name",
      label: "Name",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          return (
            <div>
              {`${allUsers[dataIndex]?.name || ""} ${
                allUsers[dataIndex]?.middleName || ""
              } ${allUsers[dataIndex]?.lastName || ""}`.trim()}
            </div>
          );
        },
      },
    },
    {
      name: "mail",
      label: "Email",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "affiliateType",
      label: "Affiliate Type",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          console.log(affiliateTypesData);
          let affiliateType = "";

          if (allUsers[dataIndex]?.affiliateDetails?.affiliateType) {
            affiliateType = affiliateTypesData.find((type) => {
              console.log("value 1" + String(type?._id));
              console.log(
                "value 2 " +
                  String(
                    JSON.stringify(
                      allUsers[dataIndex]?.affiliateDetails?.affiliateType
                    )
                  )
              );
              console.log(
                String(type?._id) ===
                  String(
                    JSON.stringify(
                      allUsers[dataIndex]?.affiliateDetails?.affiliateType
                    )
                  )
              );
              return JSON.stringify(
                allUsers[dataIndex]?.affiliateDetails?.affiliateType
              ).includes(String(type?._id));
            });
            console.log(" affiliantType: " + affiliateType?.description);
          }
          return <div>{affiliateType?.description}</div>;
        },
      },
    },
    {
      name: "role",
      label: "Package",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "createdAt",
      label: "Created Date",

      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          return (
            <div>
              {moment(allUsers[dataIndex]?.createdAt).format("YYYY-MM-DD")}
            </div>
          );
        },
      },
    },
    {
      name: "packagestatus",
      label: "Package Status",
      options: {
        filter: false,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          const isActive = allUsers[dataIndex]?.subscriptionStatus === "active";

          return (
            <span
              className="capsule"
              style={{
                backgroundColor: isActive ? "#d4f8e8" : "#f8d7da",
                color: isActive ? "#28a745" : "#dc3545",
              }}
            >
              {isActive ? "Active" : "Inactive"}
            </span>
          );
        },
      },
    },
    {
      name: "city",
      label: "City",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          return (
            <>
              <p>
                {allUsers[dataIndex]?.city === "undefined" ||
                allUsers[dataIndex]?.city === undefined
                  ? ""
                  : allUsers[dataIndex]?.city}
              </p>
            </>
          );
        },
      },
    },
    {
      name: "display",
      label: "User Status",
      options: {
        filter: false,
        sort: false,

        customBodyRenderLite: (dataIndex) => {
          return (
            <>
              <p
                className={
                  !allUsers[dataIndex]?.verified ||
                  allUsers[dataIndex]?.blockedStatus
                    ? "red-color fw-600 capsule"
                    : "green-color fw-600 capsule"
                }
                style={{
                  backgroundColor:
                    !allUsers[dataIndex]?.verified ||
                    allUsers[dataIndex]?.blockedStatus
                      ? "#f8d7da"
                      : "#d4f8e8",
                  color:
                    !allUsers[dataIndex]?.verified ||
                    allUsers[dataIndex]?.blockedStatus
                      ? "#dc3545"
                      : "#28a745",
                }}
              >
                {!allUsers[dataIndex]?.verified
                  ? "Not Verified"
                  : allUsers[dataIndex]?.blockedStatus
                  ? "Inactive"
                  : "Active"}
              </p>
            </>
          );
        },
      },
    },
    {
      name: "options",
      label: "Book/Trip View",

      options: {
        filter: false,
        sort: false,

        customBodyRenderLite: (dataIndex) => {
          return (
            <>
              <Tooltip title="User Trip List">
                <IconButton
                  aria-label="delete"
                  onClick={() =>
                    navigate("/trip-listing", {
                      state: { passedValue: allUsers[dataIndex]?._id },
                    })
                  }
                >
                  <LibraryBooksSharpIcon className="icon-size" />
                </IconButton>
              </Tooltip>
            </>
          );
        },
      },
    },
    {
      name: "options",
      label: "Options",

      options: {
        filter: false,
        sort: false,

        customBodyRenderLite: (dataIndex) => {
          return (
            <>
              <Tooltip title="View">
                <IconButton
                  aria-label="View User"
                  onClick={() => handleOpen(allUsers[dataIndex], "edit")}
                >
                  <RemoveRedEyeOutlinedIcon className="icon-size" />
                </IconButton>
              </Tooltip>
              {write ? (
                <>
                  <Tooltip
                    title={
                      !allUsers[dataIndex]?.blockedStatus
                        ? "Inactive"
                        : "Active"
                    }
                  >
                    <IconButton
                      aria-label="Block Status"
                      onClick={() =>
                        handleOpen(
                          allUsers[dataIndex]._id,
                          "delete",
                          allUsers[dataIndex]?.blockedStatus
                        )
                      }
                    >
                      <BlockOutlinedIcon className="red-color fs-16 icon-size" />
                    </IconButton>
                  </Tooltip>
                </>
              ) : (
                <></>
              )}
            </>
          );
        },
      },
    },
  ];

  const handleOpen = (userid, type, status) => {
    if (type === "delete") {
      setUserId(userid);
      setOpenDel(true);
      setStatus(status);
      setPackages("");
    } else if (type === "edit") {
      setName(userid?.name);
      setUserImg(userid?.picture);
      setEmail(userid?.mail);
      const affiliateType = affiliateTypesData.find((type) => {

          console.log("value 1 "+type?._id);
          console.log("value 2 "+userid?.affiliateDetails?.affiliateType);
          console.log((type?._id?.toString()|| '') ===(userid?.affiliateDetails?.affiliateType?.toString()||''));

          return (type?._id?.toString()|| '') ===(userid?.affiliateDetails?.affiliateType?.toString()||'');
      });
      console.log("Name: " + userid?.name + " affiliantType: " + affiliateType)

      setAffiliateType(affiliateType?.description?.toString()||'');
      setAffiliateLink(userid?.affiliateDetails?.affiliateLink);
      const data = allPackages.find((plan) => {
        return plan?.value === userid?.role;
      });
      setPackages(data);
      setGender(userid?.gender);
      setCity(userid?.city);
      setUserId(userid._id);
      setType("edit");
      setUserStatus(userid?.blockedStatus);
      setPackageStatus(userid?.subscriptionStatus);
      setOpen(true);
    } else {
      setOpen(true);
    }
  };
  const handleClose = () => {
    setOpen(false);
    setOpenDel(false);
    setType("");
    setName("");
    setStatus(true);
    setEmail("");
    setAffiliateType("");
    setPackages("");
    setGender("");
    setUserStatus(false);
    setCity("");
    setUserImg("");
    setPackageStatus("");
  };

  const handleChangeStatus = () => {
    Axios.post(process.env.REACT_APP_BACKEND + "update-user-status", {
      id: userId,
      planName: packages?.value,
    })
      .then((resp) => {
        setAllUsers(resp?.data?.data?.docs);
        setCount(resp?.data?.data?.totalDocs);
        toast.success(resp && resp.data && resp.data.message);
        handleClose();
      })
      .catch((err) => {
        toast.error(
          err && err.response && err.response.data && err.response.data.message
        );
      });
  };
  return (
    <>
      <Helmet>
        <title>Sevenly-User Management</title>
        <meta name="user" content="User Managemanet for Home Page" />
      </Helmet>
      <h1 className="mb--12 sevenly-cursor"> — </h1>
      <div className="d-flex justify-content-between mb-2">
        <h2>User Management</h2>
      </div>
      <MUIDataTable
        title={"User List"}
        data={allUsers}
        columns={columns}
        options={options}
      />

      {/* ------------------------------Create User Section ---------------------------------------- */}
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        fullWidth={true}
        open={open}
        maxWidth="md"
      >
        <div className="d-flex justify-content-between align-center p-3">
          <h3> User Details</h3>
          <IconButton onClick={handleClose}>
            <Close />
          </IconButton>
        </div>
        <DialogContent dividers>
          <div className="row">
            <div className="col-md-4">
              <Card
                sx={{
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Avatar
                  sx={{
                    width: 100,
                    height: 100,
                    fontSize: 48,
                    margin: "auto",
                    marginTop: "10px",
                  }}
                >
                  {userImg === undefined ||
                  userImg === null ||
                  userImg === "" ? (
                    <>{name ? name.charAt(0).toUpperCase() : "?"}</>
                  ) : (
                    <>
                      <img src={userImg} />
                    </>
                  )}
                </Avatar>

                <div
                  style={{
                    padding: "8px 20px",
                    border: "2px solid rgb(61, 210, 204)",
                    borderRadius: "8px",
                    backgroundColor: "rgb(61, 210, 204)",
                    boxShadow: "rgba(0, 0, 0, 0.1) 0px 2px 5px",
                    marginTop: "20px",
                    marginLeft: "auto",
                    display: "flex",
                    width: "fit-content",
                    marginRight: "auto",
                  }}
                >
                  <h3
                    className="traveller_name"
                    style={{ margin: 0, color: "white" }}
                  >
                    {name}
                  </h3>
                </div>

                <p
                  className="text-center mt-3"
                  style={{ fontWeight: "700", fontSize: "14px" }}
                >
                  <CircleIcon
                    className="pe-1"
                    sx={{
                      color: !userStatus ? "green" : "red",
                      fontSize: "14px",
                    }}
                  />
                  {!userStatus ? "Active" : "Inactive"}
                </p>
              </Card>
            </div>

            <div className="col-md-8">
              <Card className="p-3">
                <div className="d-flex justify-content-between align-center p-3 border-bottom">
                  <h3>Traveler Infomation</h3>
                </div>
                <div className="row mt-4">
                  <div className="col-md-6">
                    <TextField
                      label="Name"
                      variant="outlined"
                      fullWidth
                      className="my-2"
                      name="name"
                      value={name}
                      InputProps={{
                        readOnly: true,
                        classes: {
                          input: "custom-input",
                        },
                      }}
                    />

                    <TextField
                      label="Gender"
                      variant="outlined"
                      fullWidth
                      className="my-2"
                      name="packages"
                      value={
                        gender === "male"
                          ? "Male"
                          : gender === "female"
                          ? "Female"
                          : gender === undefined ||
                            gender === "" ||
                            gender === "undefined" ||
                            gender === null
                          ? ""
                          : ""
                      }
                      InputProps={{
                        readOnly: true,
                        classes: {
                          input: "custom-input",
                        },
                      }}
                    />

                    <Autocomplete
                      className="my-2"
                      id="tags-outlined"
                      options={allPackages}
                      value={packages}
                      getOptionLabel={(option) =>
                        option ? option.displayName : ""
                      }
                      onChange={(event, newValue) => {
                        setPackages(newValue);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          className="my-2"
                          label="Select Roles"
                          InputLabelProps={{ shrink: true }}
                        />
                      )}
                    />
                  </div>
                  <div className="col-md-6">
                    <TextField
                      label="Email"
                      variant="outlined"
                      fullWidth
                      className="my-2"
                      type="email"
                      name="email"
                      value={email}
                      InputProps={{
                        readOnly: true,
                        shrink: true,
                        classes: {
                          input: "custom-input",
                        },
                      }}
                    />
                    <TextField
                      label="City"
                      variant="outlined"
                      fullWidth
                      className="my-2"
                      name="packages"
                      value={
                        city === undefined ||
                        city === "" ||
                        city === "undefined" ||
                        city === null
                          ? ""
                          : city
                      }
                      InputProps={{
                        readOnly: true,
                        shrink: true,
                        classes: {
                          input: "custom-input",
                        },
                      }}
                    />

                    <TextField
                      label="Package Status"
                      variant="outlined"
                      fullWidth
                      className="my-2"
                      value={packagestatus === "active" ? "Active" : "Inactive"}
                      name="city"
                      InputProps={{
                        readOnly: true,
                        shrink: true,
                        classes: {
                          input: "custom-input",
                        },
                      }}
                    />
                  </div>
                </div>
              </Card>
              {
                (affiliateLink &&
                <Card className="p-3">
                <div className="d-flex justify-content-between align-center p-3 border-bottom">
                  <h3>Affiliate Setup</h3>
                </div>
                <div className="row mt-4">
                  <div className="col-md-6">
                    <TextField
                      label="Affiliate Link"
                      variant="outlined"
                      fullWidth
                      className="my-2"
                      name="affiliateLink"
                      value={affiliateLink}
                    />
                  </div>
                </div>
              </Card>
                )}
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button className="cancel-button" onClick={handleClose}>
            Close
          </Button>
          <Button
            className="submit-button"
            variant="contained"
            onClick={handleChangeStatus}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>
      {/* ------------------------Delete User---------------------------------- */}
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        fullWidth={true}
        open={opendel}
      >
        <div className="d-flex justify-content-between align-center p-3">
          <h3> User Status</h3>
          <IconButton onClick={handleClose}>
            <Close />
          </IconButton>
        </div>
        <DialogContent dividers>
          <p className="fs-14">
            {status
              ? "Are you sure you want to Active the User ?"
              : "Are you sure you want to Inactive the User ?"}
          </p>
        </DialogContent>
        <DialogActions>
          <Button className="cancel-button" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            className="submit-button"
            variant="contained"
            onClick={handleChangeStatus}
          >
            {!status ? "Inactive " : "Active "}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
export default UserManagement;
